import React from "react";
import { Select } from "antd";

const BlueBookForm = ({
  motorcycle,
  options,
  isLoading,
  handleChangeMake,
  handleChangeYear,
  handleChangeModel,
}: any) => {
  return (
    <>
      <div
        style={{ textAlign: "center", marginBottom: "50px", marginTop: "20px" }}
      >
        <h1>Blue Book Form</h1>
      </div>
      <div className="bluebook-options">
        <Select
          showSearch
          placeholder="Make"
          onChange={handleChangeMake}
          style={{ width: 200 }}
          className="bluebook-ant-select-selection"
          size="large"
          bordered={false}
          options={options?.makes}
          loading={isLoading.make}
          value={motorcycle.make}
          dropdownStyle={{ textAlign: "left" }}
          disabled={isLoading.year || isLoading.model}
        />
        <Select
          placeholder="Year"
          style={{ width: 100 }}
          onChange={handleChangeYear}
          className="bluebook-ant-select-selection "
          size="large"
          bordered={false}
          options={options?.years}
          disabled={!motorcycle.make || isLoading.year || isLoading.model}
          loading={isLoading.year}
          value={motorcycle.year}
          dropdownStyle={{ textAlign: "left" }}
        />
        <Select
          placeholder="Model"
          onChange={handleChangeModel}
          className="bluebook-ant-select-selection bluebook-model-ant-select"
          size="large"
          bordered={false}
          disabled={!motorcycle.year || isLoading.year || isLoading.model}
          options={options?.models}
          loading={isLoading.model}
          value={motorcycle.model}
          dropdownStyle={{ textAlign: "left", width: 300 }}
        />
      </div>
    </>
  );
};

export default BlueBookForm;
